// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { auroria as _auroria } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the auroria chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 205205
 * Chain Name: Auroria Testnet
 * Default Block Explorer: https://auroria.explorer.stratisevm.com
 * Default RPC URL: https://auroria.rpc.stratisevm.com
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { auroria } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: auroria,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const auroria = createCommon({
	..._auroria,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
